import React from "react";

const ABBR_STOP_WORDS = new Set([
  "of", "and", "the", "for", "in", "at", "to", "by", "or", "with",
  "inc", "llc", "corp", "co", "ltd", "company", "companies",
  "group", "groups", "holdings", "associates", "partners",
  "mortgage", "home", "loans", "loan", "bank", "banking",
  "financial", "services", "solutions", "usa", "na", "n.a.",
  "mr", "mrs", "ms", "dr",
]);

export const abbreviateBranchName = (name) => {
  if (!name) return "?";

  const rawWords = String(name)
    .trim()
    .replace(/[&\-']/g, " ")
    .replace(/\./g, "")
    .split(/\s+/)
    .filter(Boolean);

  const validWords = rawWords.filter(
    (word) => !ABBR_STOP_WORDS.has(word.toLowerCase()),
  );

  if (validWords.length >= 2) {
    return `${validWords[0][0]}${validWords[1][0]}`.toUpperCase();
  }

  const fallback = String(name).replace(/[^a-zA-Z0-9]/g, "").slice(0, 2).toUpperCase();
  return fallback || "?";
};

const BranchAvatar = ({
  name = undefined,
  short = undefined,
  color = undefined,
  className = "bs-dot",
  style = undefined,
  children = undefined,
}) => (
  <span className={className} style={{ background: color, ...style }}>
    {children ?? (name ? abbreviateBranchName(name) : short ?? null)}
  </span>
);

export default BranchAvatar;
